import Helper from "./Helper";

class SubnavigationFunctionality {
  constructor(config = {}) {
    // const { header, linkClass} = config;
    this.body = document.querySelector("body");
    this.mainWrapper = document.querySelector('.main-wrapper');
    this.subNavigation = document.querySelector('.subpageNavigation');
    this.suNaviItem = [...document.querySelectorAll('.subpageNavigation__item')];
    this.header = document.querySelector('.ns-header');

    this.subnaviLinks = [...document.querySelectorAll('.subpageNavigation__link')];

    if (this.subnaviLinks && this.subnaviLinks.length > 0) {
      this.bindEvents();
    }
  }

  bindEvents() {
    let heightOfContentContainer = this.calculateHeight(this.mainWrapper);

    window.addEventListener('resize', ()=>{
      heightOfContentContainer = this.calculateHeight(this.mainWrapper);
      this.subnaviLinks.forEach((el)=>{
        Helper.removeClass(el.parentNode, 'active');
        let elForHeight = el.parentNode.querySelector('.subpageNavigation__wrap-level2');
        elForHeight.style.height = '0px';
      });
    });

    this.subnaviLinks.forEach((element)=>{
      element.addEventListener('click', (e) => {
        let navigationElement = element.parentNode.querySelector('.subpageNavigation__wrap-level2');
        if ( navigationElement != null && typeof navigationElement != undefined ) {
          e.preventDefault();
        }
        if(!element.classList.contains('unfocus')) {
          if(element.parentNode.classList.contains('active')){
            Helper.removeClass(element.parentNode, 'active');
            navigationElement.style.height = '0px';
          } else {
            this.subnaviLinks.forEach((el)=>{
              Helper.removeClass(el.parentNode, 'active');
              Helper.removeClass(el.parentNode, 'unfocus');
              let elForHeight = el.parentNode.querySelector('.subpageNavigation__wrap-level2');
              if ( elForHeight != null && typeof elForHeight != undefined ) {
                elForHeight.style.height = '0px';
              }
            });
            navigationElement.style.height = heightOfContentContainer + 'px';
            Helper.addClass(element.parentNode, 'active');
            
            // functionallity to close the subnav if clicked anywhere than the subnav
            let openSubNavLvl2 = document.querySelector('.subpageNavigation__item.active .subpageNavigation__wrap-level2'); // needed to set the focus, through navigationElement the focus won't be set correctly
            openSubNavLvl2.focus({preventScroll: true});
            openSubNavLvl2.addEventListener('focusout', () => {
              window.setTimeout(() => {
                Helper.addClass(element, 'unfocus');
                openSubNavLvl2.style.height = '0px';
                Helper.removeClass(element.parentNode, 'active');
                Helper.removeClass(element, 'unfocus');
              }, 150);
            });
          }
        } else {
          Helper.removeClass(element, 'unfocus');
        }
        
      });
    });

    this.suNaviItem.forEach(toggler => {
      toggler.addEventListener("mouseenter", e => {
        this.positionFloater(toggler);
      });
      toggler.addEventListener("mouseleave", e => {
        if (toggler.classList.contains('active')) {
          this.positionFloater(toggler);
        } else {
          this.positionFloater(toggler, true);
        }
      });
    });
  }

  calculateHeight(element){
    let height = element.offsetHeight;
    return height;
  }

  positionFloater(elementToFloatto, reset = false) {
    let floater;
    if (elementToFloatto.closest(".subpageNavigation__items-wrap")) {
      floater = elementToFloatto.closest(".subpageNavigation__items").nextElementSibling;
    }
    if (!Helper.hasClass(floater, "is-visible")) {
      Helper.addClass(floater, "is-visible");
    }
    floater.style.left = `${elementToFloatto.getBoundingClientRect().left}px`;
    floater.style.width = elementToFloatto.offsetWidth + 'px';
    if (reset) {
      floater.style.left = "0";
      floater.style.width = '7rem';
      Helper.removeClass(floater, "is-visible");
    }
  }
}

export default SubnavigationFunctionality;
